const Video = () => {
  // on click of block-accordion__toggle, toggle aria-expanded
  const toggle = document.querySelectorAll(".block-video__summary");

  toggle.forEach((el) => {
    el.addEventListener("click", (e) => {
      const target = e.currentTarget;
      const expanded = target.getAttribute("aria-expanded") === "true";

      target.setAttribute("aria-expanded", !expanded);
    });
  });

  const trigger = document.querySelectorAll(".block-video__trigger");

  trigger.forEach((el) => {
    el.addEventListener("click", (e) => {
      var s3 = e.currentTarget.dataset.s3url;
      var vimeo = e.currentTarget.dataset.vimeooid;
      var youtube = e.currentTarget.dataset.youtubeid;
      var holder = e.currentTarget.closest(".block-video__holder");

      holder.classList.add("is--playing");
      // replace the content of holder with the relevant video iframe with autoplay
      if (s3) {
        holder.innerHTML =
          `<video controls controlsList="nodownload" autoplay src="${s3}"></video>`;
      } else if (vimeo) {
        holder.innerHTML =
          '<iframe src="https://player.vimeo.com/video/' +
          vimeo +
          '?autoplay=1" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>';
      } else if (youtube) {
        holder.innerHTML =
          '<iframe width="560" height="315" src="https://www.youtube.com/embed/' +
          youtube +
          '?autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
      }
    });
  });
};

export default Video;
